import { Watch, Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import CommentModel from '@/views/Project/Comment/models/comment'

import UserAvatar from '@/_components/avatar/nuser/user.vue'
import WatchersComponent from '@/views/Watcher/components/watchers/watchers.vue'
import EditorViewer from '@/components/EditorViewer/EditorViewer.vue'
import CommentInputComponent from '@/views/Project/Comment/components/commentInput/commentInput.vue'

import ReactionModel from '@/views/Project/Comment/models/reaction'
import { reactionsType, reactionsAll } from '@/views/Project/Comment/models/reaction'
import AttachmentModel from '@/views/Attachment/model/attachment'
import ThreadModel from '../../models/thread'

@Component({
    inheritAttrs: false,
    name: 'comment-component',
    components: { UserAvatar, WatchersComponent, EditorViewer, CommentInputComponent },
})
export default class CommentComponent extends Mixins<MixinInterface>() {
    @Prop({ required: true }) comment!: CommentModel
    @Prop({ required: true }) thread!: ThreadModel
    @Prop({ default: false }) writableAttachmentToResource!: boolean
    @Prop({ default: false }) isPreloadReplies!: boolean

    get replies() {
        return this.comment.replies
    }

    get commentId() {
        return this.comment._id
    }

    @Watch('commentId', { immediate: true })
    async preloadReplies() {
        if (this.isPreloadReplies && this.comment.numReplies > this.replies.length) {
            this.limit = 200
            this.offset = this.replies.length
            await this.loadReplies()
        }
    }

    edit = false

    editComment() {
        this.edit = true
    }

    closeEdit() {
        this.edit = false
    }

    reply = false

    replyToComment() {
        this.reply = true
    }

    closeReply() {
        this.reply = false
    }

    loadingReplies = false
    offset = 0
    limit = 10

    async loadReplies() {
        this.loadingReplies = true

        let filters = {
            'filter[parent]': this.comment._id,
            'page[offset]': this.offset,
            'page[limit]': this.limit,
        }

        await this.comment.loadReplies(filters).catch(() => {
            //
        })

        this.offset += this.limit
        this.loadingReplies = false
    }

    loadingDelete = false

    async showAttachment(attachment: AttachmentModel) {
        let res: any = await attachment.showLog(attachment, {
            ...(this.writableAttachmentToResource && {
                add: 'fe_observation.observation.add_comment_attachment.tooltip',
            }),
        })

        if (res && res.delete) {
            let index = this.comment.attachments.findIndex((item) => item._id == attachment._id)
            this.comment.attachments.splice(index, 1)
        }
        if (res && res.add) {
            this.$emit('writeAttachmentToResource', attachment)
        }
    }

    async toggleDelete(val: boolean) {
        this.loadingDelete = true
        await this.comment.toggleDelete(val)
        this.loadingDelete = false
    }

    reactionsAll = reactionsAll

    async thumbsup() {
        let res = await ReactionModel.post(this.comment._id, 'thumbsUp')
        if (res) {
            this.comment.reactions = [...this.comment.reactions, res]
        }
    }

    async toggleReaction(reaction: ReactionModel | null, reactionType: reactionsType) {
        let res: any = null
        if (reaction) {
            if (reaction.canDelete) {
                let index = this.comment.reactions.findIndex((item) => item._id == reaction._id)
                res = await reaction.delete()
                this.comment.reactions.splice(index, 1)
            }
        } else {
            res = await ReactionModel.post(this.comment._id, reactionType)
            this.comment.reactions = [...this.comment.reactions, res]
        }
    }

    // Manage attachment
    async writeToResource(attachment) {
        if (this.writableAttachmentToResource) {
            this.$emit('writeAttachmentToResource', attachment)
        }
    }

    loadingAttachmentDelete = new Set()

    async deleteAttachment(attachment) {
        if (attachment.canDelete) {
            this.loadingAttachmentDelete.add(attachment._id)
            await attachment?.delete(attachment)

            this.comment.attachments = this.comment.attachments.filter(
                (att) => att._id != attachment._id
            )
            this.loadingAttachmentDelete.delete(attachment._id)
        }
    }
}
